const GallerySection = () => {
  const galleryImages = [
    {
      id: 1,
      src: "https://images.pexels.com/photos/4439740/pexels-photo-4439740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Biryani tradicional",
      span: "md:col-span-4 lg:col-span-5 row-span-2"
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1618449840665-9ed506d73a34?crop=entropy&cs=srgb&fm=jpg&w=600",
      alt: "Curry aromático",
      span: "md:col-span-4 lg:col-span-4"
    },
    {
      id: 3,
      src: "https://images.pexels.com/photos/19418741/pexels-photo-19418741.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Variedad de platos",
      span: "md:col-span-4 lg:col-span-3"
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1768697358705-c1b60333da35?crop=entropy&cs=srgb&fm=jpg&w=600",
      alt: "Interior del restaurante",
      span: "md:col-span-4 lg:col-span-4"
    },
    {
      id: 5,
      src: "https://images.pexels.com/photos/7625056/pexels-photo-7625056.jpeg?auto=compress&cs=tinysrgb&w=600",
      alt: "Butter Chicken",
      span: "md:col-span-4 lg:col-span-3"
    }
  ];

  return (
    <section 
      id="galeria" 
      className="section-padding bg-[#F5EFE6]"
      data-testid="gallery-section"
    >
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="overline mb-4 block">Nuestra Galería</span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-[#2D231E] mb-4">
            Un Festín Visual
          </h2>
          <p className="font-sans text-base md:text-lg text-[#5C4D43] max-w-2xl mx-auto">
            Descubre la belleza de nuestros platos y el ambiente acogedor de nuestro restaurante.
          </p>
        </div>

        {/* Bento Grid Gallery */}
        <div className="bento-grid">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`${image.span} relative overflow-hidden rounded-2xl group animate-fade-in-up opacity-0`}
              style={{ 
                animationDelay: `${index * 100}ms`,
                animationFillMode: 'forwards',
                minHeight: '200px'
              }}
              data-testid={`gallery-image-${image.id}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D231E]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4">
                  <span className="font-sans text-sm text-[#FDFBF7] font-medium">
                    {image.alt}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
